import { useState, useCallback } from "react";
import { urlRegex, UrlValidations } from "@/constant";

const useUrlInput = (initialValue: string, t: any) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState<string | null>(null);
  const [clickedOutside, setClickedOutside] = useState<boolean>(false);

  const isValidURL = (url: string): boolean => {
    return urlRegex.test(url);
  };
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value.trim();

    if (newValue === "" || newValue.startsWith("h") || newValue.includes("://")) {
      setError(null);
    } else {
      newValue = `https://${newValue}`;
    }

    if (isValidURL(newValue)) {
      setError(null);
    } else {
      setError(t(UrlValidations.invalidUrl));
    }

    setValue(newValue);
  }, []);

  const handleClear = useCallback(() => {
    setValue("");
    setError(null);
  }, []);

  const handleInputBlur = useCallback(() => {
    if (!clickedOutside && error && (value.startsWith("h") && !value.includes("://"))) {
      setClickedOutside(true);
    }
  }, [value, error]);

  return { value, error, handleChange, handleClear, clickedOutside, handleInputBlur };
};

export default useUrlInput;
